import { Component, Input, OnInit } from '@angular/core'; 

@Component({
  selector: 'ess-icon', 
  template: '<span class="material-icons material-symbols-outlined "> {{ iconName }} </span>'
})
export class IconComponent { 
  @Input() iconName: any
}
